const FeatureSchema = {
    refresh: {
        show: false,
    },
    logging: {
        request: false,
    },
    ontacs: {
        allowBlockedOUIs: false,
        allowBlockedManufacturers: false,
        allowBlockedProductClasses: false,
        allowBlockedSerialNumbers: false,
        randomizeInform: false,
        tryAlternativeProvisioning: false,
        disableRefreshOnValueChange: false,
        handleTransferComplete: false,
        refreshUnknownWANs: false,
        enablePeriodicInform: false,
        refreshResources: false,
    },
    daemon: {
        skipXenditScraping: false,
        skipGenerateAssociateTaxes: false,
    },
    accountingUpdateOne: {
        ont: false,
        ppp: false,
        hotspot: false,
    },
    dataImport: {
        disableCustomerImport: false,
    },
    rendering: {
        limitMaxTab: false,
        logRequests: false,
    },
    radius: {
        nasCaching: false,
        singleAddress: false,
    },
    whatsApp: {
        skipUsageLimitCheck: false,
    },
    xendit: {
        checkBeforeCancellation: false,
        useNewDisbursementFeeCalculation: false,
        useExtraFeeCalculation: false,
        useExtraFeeInSystemCalculation: false,
        disableDisbursement: false,
    },
} satisfies Record<string, Record<string, false>>;

export type FeatureSchema = typeof FeatureSchema;
export const Features: Record<string, Record<string, boolean>> = structuredClone(FeatureSchema);
export type Features = typeof Features;
